import { Component, Input, OnInit, ViewChild } from '@angular/core';
import html2canvas from 'html2canvas';
import { ConstantsModule } from 'src/app/common/constants/constants.module';
import { SubmitdataService } from 'src/app/services/submitdata/submitdata.service';
import { isNullOrUndefined } from 'util';
import {jsPDF} from "jspdf";
import { AuthloginService } from 'src/app/services/login/authlogin.service';
import { meetingModuleUpload } from 'src/assets/i18n/en.json';
import { districtsdata , tabledataforstates , setDropDown ,indicatorlist} from 'src/assets/i18n/hi.json';



@Component({
  selector: 'app-meeting-attendance-report',
  templateUrl: './meeting-attendance-report.component.html',
  styleUrls: ['./meeting-attendance-report.component.css']
})
export class MeetingAttendanceReportComponent implements OnInit {
  yearDropDownList: any;
  attendancefilter: object = {'ay':"","month":""};
  monthsList:any = [
    { key: '04' ,value: 'April' , hivalue:'अप्रैल'},
    { key: '05' ,value:'May' , hivalue:'मई'},
    { key: '06' ,value: 'June' , hivalue:'जून'},
    { key: '07' ,value:'July' , hivalue:'जुलाई'},
    { key: '08' ,value: 'August' , hivalue:'अगस्त'},
    { key: '09' ,value:'September' , hivalue:'सितम्बर'},
    { key: '10' ,value: 'October' , hivalue:'अक्टूबर'},
    { key: '11' ,value:'November' , hivalue:'नवंबर'},
    { key: '12' ,value: 'December' , hivalue:'दिसंबर'},
    { key: '01' ,value:'January' , hivalue:'जनुअरी'},
    { key: '02' ,value: 'February' , hivalue:'फेब्रुअरी'},
    { key: '03' ,value:'March' , hivalue:'मार्च'},
  ];
  selectedMonths=0;
  designationList:any=[];
  statelists: any[];
  districtsList: any[];
  activeSpinner: boolean;
  makeempty=false;
  selectedstate: any;
  showdistdrop: boolean;
  filterdistrict: any;
  selectedDist: any;
  selectedDesignation: any;
  attTableData: any;
  showMonthCol: boolean;
  showprintData: boolean;
  userDetails;
  onadditem:boolean=false;
  dropdownSettings: any = {
    singleSelection: false,
    idField: 'key',
    textField:'value',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    noDataAvailablePlaceholderText: 'No data available.',
    itemsShowLimit: 1,
    allowSearchFilter: true
  };
  hidropdownSettings: any = {
    singleSelection: false,
    idField: 'key',
    textField:'hivalue',
    selectAllText: setDropDown.selectAllText,
    unSelectAllText: setDropDown.unSelectAllText,
    noDataAvailablePlaceholderText: setDropDown.noDataAvailable,
    itemsShowLimit: 1,
    allowSearchFilter: true
  };
  firstItemEntered: boolean=false;
  selectedOptions: any;
  itemSelectCount=0;
  monthNames: any;
  @Input() selectedlanguage:string;
  
  constructor(private submitdataSerivce : SubmitdataService,
    private constants : ConstantsModule,
    private loginsrv : AuthloginService
    ) { }

  ngOnInit() {
    this.submitdataSerivce.getStatusOfToken();
    this.userDetails=this.loginsrv.checkloginstatus();
    Object.keys(meetingModuleUpload).forEach(element => {
      this.designationList.push(element);      
    });
    this.getdynamicYears();
    this.setCurrentMonthDefault();
    this.getstateslist();
    if (this.userDetails['roles'][0]=='STATE_GANGA_COMMITTEE' || this.userDetails['roles'][0]=='DISTRICT_GANGA_COMMITTEE'){
      this.selectedstate=this.userDetails['loggedUserData']['userProfile']['stateUUID'];
      this.showdistrictdropdown(this.selectedstate);
      if (this.userDetails['roles'][0]=='DISTRICT_GANGA_COMMITTEE')
        this.selectedDist=this.userDetails['loggedUserData']['userProfile']['locationId'];
    } 
  }
  onItemSelect(item: any){   
    this.addItem(item,'');
  }
  onItemDeSelect(item: any) {
    this.removeItem(item,'');
  }
  onItemDeSelectAll(items: any) {
    this.removeItem(items, 'all');
  }
  onSelectAll(items: any) {
    this.addItem(items, 'all');
  }

  addItem(item, option) {
    if(this.firstItemEntered==false)
      this.selectedOptions = [];
    
    if (option == 'all') {
      this.selectedOptions= [];
      this.selectedOptions=item;
      this.firstItemEntered=true;
    }
    else if(option==''){
      this.firstItemEntered=true;
      this.selectedOptions.push(item);
      this.itemSelectCount=this.itemSelectCount + 1;
      this.onadditem=true;  
    }
    if (this.selectedlanguage=='hi'){
      this.selectedOptions.forEach(month=>{
        this.monthsList.forEach(obj=>{
          if(month['key']==obj['key']){
            month['value']=obj['value'];
          }
        })
      })
    }
    this.selectedMonths=this.selectedOptions.length;
    this.selectedDesignation="";
  }
  removeItem(item, option) {
    this.onadditem=false;
    if (option == 'all') {
      this.selectedOptions = [];
      this.itemSelectCount=0;
    } 
    else if (option=='') {
        for (let i = 0; i < this.selectedOptions.length; i++) {            
          if (this.selectedOptions[i]['key']==item['key'])
            {
              this.selectedOptions.splice(i,1);
            }
      }
    } 
    this.selectedMonths=this.selectedOptions.length;
    this.selectedDesignation="";
  }

  getdynamicYears() {
    let date = new Date();
    let currentYear = date.getFullYear();
    let currentmonth = date.getMonth();
    let dropDownYear;
    if (currentmonth < 3) {
      dropDownYear = (currentYear - 1) + '-' + currentYear;
    } else {
      dropDownYear = currentYear + '-' + (currentYear + 1);
    }
    this.submitdataSerivce.getYearsToDisplay(this.submitdataSerivce.yearsPayload).subscribe(data => {
      this.yearDropDownList = data['data'];
    });
    this.attendancefilter['ay'] = dropDownYear;
    // this.abstractYear = this.attendancefilter['ay'].split('-');
    // this.currentYearVar = currentYear;    
  }

  setCurrentMonthDefault() {
    let currentmonth = new Date().getMonth()
    let currentmonthObj;
    this.monthsList.forEach(monthObj => {
      if (parseInt(monthObj['key']) == currentmonth + 1) {
        currentmonthObj = monthObj;
      }
    });
    this.attendancefilter['month'] = currentmonthObj['key'];
    this.selectedDesignation = "None";
    // this.currentMonthVar = currentmonthObj['value'];
  }

  getstateslist() {
    let postdata = {};
    this.statelists = [];
    postdata['pType'] = this.constants.LOCATION_CONSTANT['BASIN'];
    postdata['cType'] = this.constants.LOCATION_CONSTANT['STATE'];
    postdata["component"] = "";
    postdata["src"] = "";
    this.submitdataSerivce.getLocationList(postdata).subscribe(data => {
      if (data) {
        this.statelists = [];
        Object.keys(data).forEach(key => {
          data[key].forEach(statelist => {
            this.statelists.push(statelist);
            this.statelists.sort((a, b) => (a.name > b.name) ? 1 : -1);
          });
        })
      }
    });
  }

  showdistrictdropdown(stateuuid) {
    this.filterdistrict = stateuuid;
    if (stateuuid) {
      this.getDistrictList();
      this.showdistdrop = true;
    } else {
      this.showdistdrop = false;
    }
    this.selectedDesignation=""
;  }

  getDistrictList() {
    this.districtsList = [];
    let postdata = {
      'pType': this.constants.LOCATION_CONSTANT['STATE'],
      'cType': this.constants.LOCATION_CONSTANT['DISTRICT'],
      'puuid': this.filterdistrict
    }
    this.submitdataSerivce.getLocationListforUser(postdata).subscribe(data => {
      if (Array.isArray(data)) {
        // this.districtsList = data;
        let temphold=[];
        this.districtsList.sort();
        data.forEach(dKey => {
          temphold.push(dKey);
          temphold.sort((a, b) => (a.name > b.name) ? 1 : -1);

        })
        this.districtsList = temphold;
      }
    }, function (err) {
      this.activespineer = false;
      if (err['error']) {
        this.toastr.error(err['error']['msg'])
      }
    })
  }

  showAttendanceData() {
    let postdata = {
      "ay": this.attendancefilter['ay'],
      "lu": this.selectedDist
    }
    let tableData = {};
    this.submitdataSerivce.getDGCMeetingReport(postdata).subscribe(data => {
      if (!isNullOrUndefined(data) && data['status']) {
        this.monthsList.forEach(month => {
          Object.keys(data['data']).forEach(dataobj => {
            let number = dataobj.substring(4, 6);
            if (month.key == number) {
              tableData[month.key] = data['data'][dataobj];
            }
          })
        })
        // console.log("statuss", tableData);
      }
      this.getAttendanceData(postdata, tableData);
    })
  }

  getAttendanceData(postdata, statusData) {
    // if (this.attendancefilter['month'] != 'ALL') {
    //   postdata['subTp'] = [this.attendancefilter['month']];
    //   this.showMonthCol=false;
    // } else {
    //   postdata['subTp'] = ["04", "05", "06", "07", "08", "09", "10", "11", "12", "01", "02", "03"];
    //   this.showMonthCol = true;
    // }
    let selectedmonths=[];
    this.monthNames=[];
    let montemp=[];
    this.selectedOptions.forEach(month=>{
      selectedmonths.push(month['key']);
      montemp.push(month['value']);

    })
    this.monthNames=montemp;
    postdata['subTp']=selectedmonths;
    this.showMonthCol=true;
    let i=1;
    this.submitdataSerivce.dgcAttendanceStatus(postdata).subscribe(res => {
      this.attTableData = [];
      let j=1;
      this.designationList.forEach(designation =>{
        let row={};
        row['sno']=i;
        row['designation']=designation;
        i++;
        this.selectedOptions.forEach(month=>{
              if (res[month.key] && res[month.key] != "Not Held")// && statusData[month.key] == "Submitted") 
              {
                let memberfound=false;
                res[month.key].forEach(obj => {
                  if (obj['officials']==designation){
                      memberfound=true;
                      if (obj['attendance']=='yes'){
                        row[month.value]='P';
                      }
                      else if (obj['attendance']=='no'){
                        row[month.value]='A';
                      }
                  }
    
                })
                if (!(memberfound)){
                  row[month.value]='A';
                }
    
              }
              else{
                row[month.value]='Not Held'
              }
          
        })
        // this.monthsList.forEach(month=>{
        //   if (res[month.key] && res[month.key] != "Not Held" && statusData[month.key] == "Submitted") 
        //   {
        //     // row['month']=month.value;
        //     let memberfound=false;
        //     res[month.key].forEach(obj => {
        //       if (obj['officials']==designation){
                
        //         console.log('offff',obj['officials']);
        //         memberfound=true;
        //           if (obj['attendance']=='yes'){
        //             row[month.value]='P';
        //           }
        //           else if (obj['attendance']=='no'){
        //             row[month.value]='A';
        //           }
        //       }

        //     })
        //     if (!(memberfound)){
        //       row[month.value]='-';
        //     }

        //   }
        // })
        if (this.selectedDesignation=='None' || this.selectedDesignation=='')
        {
            this.attTableData.push(row);
        }
        else{
          if (row['designation']==this.selectedDesignation){
            this.attTableData.push(row);
          }
        }
      })
      
    })
    this.showprintData = true;
  }

  printTable(){
    let monthName, stateName, districtName;
    this.monthsList.forEach(element => {
      if (this.attendancefilter['month'] == element['key']) {
        monthName = element['value'];
      }
    });
    if(this.attendancefilter['month']=="ALL"){
      monthName="All Months";
    }
    this.statelists.forEach(state =>{
      if(this.selectedstate == state['uuid']){
        stateName = state['name'];
      }
    })
    this.districtsList.forEach(dist =>{
      if(this.selectedDist == dist['uuid']){
        districtName = dist['name'];
      }
    })

    let label = "Meeting Attendance Report for Assessment Year " + this.attendancefilter['ay'] + " District " + districtName + " , " + this.TitleCaseConverter(stateName) ; // for " + monthName";
      this.activeSpinner = true;
      let DATA = document.getElementById('content');
      html2canvas(DATA).then(function(canvas) {
        canvas.getContext('2d');
         var HTML_Width = canvas.width;
        var HTML_Height = canvas.height;
        var top_left_margin = 15;
        var PDF_Width = HTML_Width+(top_left_margin*2);
        var PDF_Height = (PDF_Width*1.5)+(top_left_margin*2);
        var canvas_image_width = HTML_Width;
        var canvas_image_height = HTML_Height;        
        var totalPDFPages = Math.ceil(HTML_Height/PDF_Height)-1;
        // console.log(canvas.height+"  "+canvas.width);        
        var imgData = canvas.toDataURL("image/jpeg", 1.0);
        var pdf = new jsPDF('p', 'pt',  [PDF_Width, PDF_Height]);
        // pdf.addImage(imgData, 'JPG', top_left_margin, top_left_margin,canvas_image_width,canvas_image_height);

            // ~~~~~~~~ below 3 lines are for heading of the pdf 1st page ~~~~~`
        pdf.setFontSize(20);
        pdf.text(label, 20,27);
        pdf.addImage(imgData, 'JPG', top_left_margin, top_left_margin+30,canvas_image_width,canvas_image_height);        
        
        for (var i = 1; i <= totalPDFPages; i++) {           
        pdf.addPage([PDF_Width, PDF_Height]);
        let margin=-(PDF_Height*i)+(top_left_margin*4);
        if(i>1){
        margin=margin+i*8;
        }
        // console.log(top_left_margin);
        // console.log(top_left_margin);
        // console.log(-(PDF_Height*i)+(top_left_margin*4));
        pdf.addImage(imgData, 'JPG', top_left_margin, margin,canvas_image_width,canvas_image_height);
        }        
        pdf.save("AttendanceList.pdf");
      });
      this.activeSpinner = false;
  }

  printAllDIstsTable(){
    let postdata = {
      "ay"  : this.attendancefilter['ay'],
      "pu"  : this.selectedstate,
      "lu"  :  "all"
    };
    // if (this.attendancefilter['month'] != 'ALL') {
    //   postdata['subTp'] = [this.attendancefilter['month']];
    // } else {
    //   postdata['subTp'] = ["04", "05", "06", "07", "08", "09", "10", "11", "12", "01", "02", "03"];
    // }
    let selectedmonths=[]
    this.selectedOptions.forEach(month=>{
      selectedmonths.push(month['key']);

    })
    postdata['subTp']=selectedmonths;
    this.submitdataSerivce.downloadDGCsAttendanceReports(postdata).subscribe(res =>{
      // console.log("resss",res);      
      let filename = "Attendance Report";
      var newBlob = new Blob([res],{type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
      const data = window.URL.createObjectURL(newBlob);
      var link = document.createElement('a');
      link.href = data;
      link.download = filename;
      link.dispatchEvent(new MouseEvent('click', {bubbles: true, cancelable: true, view: window}));

      setTimeout(function() {
        window.URL.revokeObjectURL(data);
        link.remove();
      },100);
    })
  }
  displayempty(){
    this.attTableData=[];
    this.selectedOptions=[];
    this.selectedMonths=0;
    this.attendancefilter['month']="";
    this.selectedDesignation="";
    this.makeempty=true;
  }
  TitleCaseConverter(str) {
    return str.replace(
      /\w\S*/g,
      function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      }
    );
  }

}
